import freezeScrolling from './freeze-scrolling'

export default freezeScrolling
